import { render } from "./Tabs.vue?vue&type=template&id=3cf645fe"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"
script.render = render

export default script